"use client";

import { useRef, useState } from "react";
import { createBreakpoint } from "react-use";
import ReactLightbox, { SlideImage } from "yet-another-react-lightbox";
import Inline from "yet-another-react-lightbox/plugins/inline";
import Thumbnails from "yet-another-react-lightbox/plugins/thumbnails";

import NextJsImage from "./lightbox-image";

const useBreakpoint = createBreakpoint();
const Lightbox = ({
	images,
}: // index,
// open,
// setOpen,
{
	images: SlideImage[];
	// index: number;
	// open: boolean;
	// setOpen: (p: boolean) => void;
}) => {
	const breakpoint = useBreakpoint();
	const [open, setOpen] = useState(false);
	const [index, setIndex] = useState(0);
	const thumbnailsRef = useRef<any>(null);

	const toggleOpen = (state: boolean) => () => setOpen(state);

	const updateIndex = ({ index: current }: { index: number }) => setIndex(current);
	return (
		<>
			<ReactLightbox
				index={index}
				slides={images}
				plugins={[Inline, Thumbnails]}
				on={{
					view: updateIndex,
					click: toggleOpen(true),
				}}
				carousel={{
					preload: 10,
					padding: 0,
					spacing: 10,
					imageFit: breakpoint === "tablet" ? "contain" : "cover",
				}}
				inline={{
					style: {
						cursor: "pointer",
						width: "100%",
						maxWidth: "100%",
						aspectRatio: breakpoint === "tablet" ? 1 : 1.2,
						margin: "0 auto",
					},
				}}
				thumbnails={{
					imageFit: "contain",
					padding: 0,
					gap: 0,
					border: 0,
				}}
			/>
			<ReactLightbox
				index={index}
				slides={images}
				plugins={[Thumbnails]}
				open={open}
				on={{ view: updateIndex }}
				close={() => setOpen(false)}
				render={{ slide: NextJsImage }}
				controller={{ closeOnPullDown: true, closeOnBackdropClick: true }}
				carousel={{
					preload: 8,
				}}
				thumbnails={{
					imageFit: "contain",
					padding: 0,
					gap: 0,
					border: 0,
				}}
			/>
			{/* <ReactLightbox
				plugins={[Thumbnails]}
				thumbnails={{ ref: thumbnailsRef }}
				on={{
					click: () => {
						(thumbnailsRef.current?.visible ? thumbnailsRef.current?.hide : thumbnailsRef.current?.show)?.();
					},
				}}
			/> */}
		</>
	);
};

export default Lightbox;
